module.exports = __webpack_public_path__ + "static/media/Polis_Logo.908e9c97.png";